import type { IUserManager } from '@sravni/utils/lib/auth';
import { IframeUserManager } from '@sravni/utils/lib/auth';

import { getUserManager } from './getUserManager';

let userManager: IUserManager | null = null;

export class UserManagerFactory {
    constructor() {
        this.createUserManager();
    }

    createUserManager() {
        if (typeof window === 'undefined') {
            throw new Error('UserManagerFactory is not available on the server');
        }

        userManager = getUserManager();

        return userManager;
    }

    getUserManager() {
        return userManager;
    }

    async getAccessToken() {
        if (userManager instanceof IframeUserManager) {
            const accessToken = await userManager.getAccessToken();

            if (accessToken.isErr()) {
                return null;
            }
            return accessToken.value;
        }

        return null;
    }
}
